(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('InsertTemplateController', InsertTemplateController);

    InsertTemplateController.$inject = ['$controller','$sce','$uibModalInstance', 'entity', 'AlertService', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];
    
    function InsertTemplateController($controller, $sce, $uibModalInstance, entity, AlertService, parameters, SoopkitchenUtils, Planning, PlanTypes) {

        var vm = this;
        var title = 'Insert a Template into Plan <span class="label label-info">'+entity.label+'</span>, Version <span\n' +
            'class="label label-info">'+entity.internalVersion+'</span>';
        angular.extend(this, $controller('SoopkitchenDialogController',
            {"title": title, $sce: $sce, $uibModalInstance:$uibModalInstance}));
        
        /**** Properties ****/

        vm.plan = entity;
        vm.planType = parameters.planType;
        vm.isTemplate = vm.planType === PlanTypes['template'];
        vm.isSoop = vm.planType === PlanTypes['soop'];
        vm.isTimelineWithNoDates = vm.isTemplate || vm.isSoop;
        if (vm.isTimelineWithNoDates) {
            vm.datePattern = null;
            vm.anchorTime = SoopkitchenUtils.timeStringElapsed(vm.plan.validityStartTime, parameters.anchorTime);
        } else {
            vm.anchorTime = parameters.anchorTime;
            vm.datePattern = "/^(\\d+d)?(\\d+h)?(\\d+m)?(\\d+s)?$/";
        }
        vm.templates = [];
        vm.selectedTemplate = null;
        
        //Overriding Properties from SoopkitchenDialogController:
        vm.saveDisabled = true;
    
        /**** Methods ****/
        //Override Methods from SoopkitchenDialogController
        vm.save = importTemplate;
        vm.isValidDate = isValidDate;
        
        Planning.getAllLatestPlans(
            {
                planType: PlanTypes['template']
            },
            function onSuccess(data) {
                for (var i = 0; i < data.length; i++) {
                    if (vm.plan.observationDefinitions.label === data[i].observationDefinitionsLabel) {
                        var baselined = true;
                        var label = data[i].label;
                        if (data[i].baselineVersion === 0) {
                            baselined = false;
                            label += ' (not baselined)'
                        } 
                        vm.templates.push({
                            label: label,
                            disabled: !baselined
                        });
                    }
                }
            });

       
        function isValidDate(date) {
            
            if (date === null || date === '') {
                vm.saveDisabled = true;
                return false;
            }

            if (vm.isTimelineWithNoDates) {
                if (isNaN(SoopkitchenUtils.timeToSeconds(date)) || SoopkitchenUtils.timeToSeconds(date) === 0) {
                    vm.saveDisabled = true;
                    return false;
                }
                date = SoopkitchenUtils.addTimeStringToDate(vm.plan.validityStartTime, date);
            }
            
            vm.saveDisabled = vm.selectedTemplate === null || (false === SoopkitchenUtils.isValidDate(date));
            return SoopkitchenUtils.isValidDate(date) ;
        }
        
        function importTemplate() {
            var time;
            if (vm.isTimelineWithNoDates) {
                time = SoopkitchenUtils.addTimeStringToDate(vm.plan.validityStartTime, vm.anchorTime);
            } else {
                time = vm.anchorTime;
            }
            Planning.importTemplate(
                {
                    planType: vm.planType,
                    planLabel: vm.plan.label,
                    importLabel: vm.selectedTemplate.label,
                    anchorDate: time
                },
                function successCallback(data) {
                    SoopkitchenUtils.updatePlanFromDialog(data);
                    $uibModalInstance.dismiss('cancel');

                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }
    }
})();
